document.addEventListener("DOMContentLoaded", function () {
    const authContainer = document.querySelector(".auth-container");

    if (!authContainer) return;

    const authForm = document.getElementById("authForm");
    const verificationScreen = document.getElementById("verificationScreen");
    const resendButton = document.getElementById("resendButton");
    const timerElement = document.getElementById("timer");
    const verifyButton = document.querySelector("#verificationScreen button");
    const verificationCodeInput = document.getElementById("verificationCode");

    let generatedCode = "";
    let cooldown = 30;
    let interval;

    authForm.addEventListener("submit", function (event) {
        event.preventDefault();
        sendCode();
    });

    resendButton.addEventListener("click", function () {
        sendCode();
    });

    verifyButton.addEventListener("click", function () {
        validateCode();
    });

    function sendCode() {
        // Faking for now
        // Generate a 6-digit verification code
        generatedCode = Math.floor(100000 + Math.random() * 900000).toString();
        console.log("Generated Code:", generatedCode); 

        // Hide the form and show verification screen
        authForm.classList.add("hidden");
        verificationScreen.classList.remove("hidden");

        startCooldown();
    }

    function startCooldown() {
        resendButton.disabled = true;
        cooldown = 30;
        timerElement.innerText = cooldown;

        interval = setInterval(() => {
            cooldown--;
            timerElement.innerText = cooldown;

            if (cooldown <= 0) {
                clearInterval(interval);
                resendButton.disabled = false;
                timerElement.innerText = "0";
            }
        }, 1000);
    }

    function validateCode() {
        const userCode = verificationCodeInput.value.trim();

        if (userCode === generatedCode) {
            alert("Code verified successfully!");
            console.log("User verified!");
        } else {
            alert("Invalid code. Please try again.");
            console.log("Incorrect code entered.");
        }
    }
});